// AUTO-GENERATED by portal/scripts/count-catalog.ts — do not edit by hand.
//
// The two catalogue numbers the copy interpolates as {{toolCount}} and
// {{skillCount}}, resolved from serac-labs/serac@main and baked into the
// bundle at build time. Baked in, not fetched, because a number in copy has to
// be right at first paint: a runtime fetch either renders a placeholder or
// renders one number and then swaps it, and a mutated i18next default does not
// re-render React at all — which is precisely how a hardcoded seed used to win.
//
// This file is committed so type-check, tests and `npm run dev` work without
// network. Every `npm run build` regenerates it from the source above, and the
// build fails rather than shipping a number it could not resolve.
//
//   Regenerate:  npx tsx portal/scripts/count-catalog.ts --write
//   Check drift: npx tsx portal/scripts/count-catalog.ts --check

export const CATALOG_COUNTS = {
  /** MCP tools in packages/servicenow-mcp/tools.json. */
  toolCount: 446,
  /** Directories under packages/skills/ that contain a SKILL.md. */
  skillCount: 70,
} as const

/** Where a reader can count the same things themselves. */
export const CATALOG_SOURCE_URLS = {
  tools: 'https://github.com/serac-labs/serac/blob/main/packages/servicenow-mcp/tools.json',
  skills: 'https://github.com/serac-labs/serac/tree/main/packages/skills',
} as const
